module.exports = __webpack_public_path__ + "static/media/19.97ef738a.svg";